import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import DatePicker from "react-datepicker";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  getSetupDetails,
  getState,
  saveSetupWizardForm,
} from "../../../Redux/actions";
import SWInterface from "../../Components/Layout/SWInterface";
import MyGoogleMap from "../../Components/GoogleMap/MyGoogleMap";
import ErrorContainer from "../../Components/ErrorContainer";
import moment from "moment";
import BtmButtons from "../../Components/BtmButtons";
import { checkNull } from "../../../helpers";

const schema = yup
  .object({
    company_name: yup.string().required(),
    balance_sheet_name: yup.string(),
    balance_sheet: yup.string(),
    company_name: yup.string().required(),
    account_name: yup.string().required(),
    incorporation_date: yup.string().required(),
    company_tax_id: yup.string().required(),
    sales_tax_rate: yup.string().required(),
    timezone: yup.string().required(),
    currency: yup.string().required(),
    zip_code: yup.string().required(),
    address: yup.string().required(),
    address_2: yup.string().nullable(),
    parent_code: yup.string().nullable(),
    country_id: yup.string().required(),
    city_id: yup.string().required(),
    state_id: yup.string().required(),
    latitude: yup.string().required(),
    longitude: yup.string().required(),
  })
  .required();
const SetupWizardTwo = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    account,
    timezones,
    currencies,
    parent_merchant,
    parent_balance_sheets,
    states,
    country,
    parent_currency,
    parent_name,
  } = useSelector((state) => state.authReducer.setup_wizard_details);
  const { states: apiStates } = useSelector((state) => state.authReducer);
  const [timezoneArr, setTimezoneArr] = useState(null);
  const [currenciesArr, setCurrenciesArr] = useState([]);
  const [parentBalanceSheetsArr, setParentBalanceSheetsArr] = useState([]);
  const [stateArr, setStateArr] = useState(null);
  const [countryArr, setCountryArr] = useState(null);
  const [balanceSheetId, setBalanceSheetId] = useState(
    account?.merchant?.is_new_balance_sheet ?? ""
  );
  const isLogoutRef = useRef(false);
  const submitBtnRef = useRef(null);

  const [inputForm, setInputForm] = useState({
    balance_sheet_name: account?.merchant?.merchant_balance_sheet_id ?? "",
    balance_sheet: account?.merchant?.is_new_balance_sheet ?? "",
    company_name: "",
    incorporation_date: "",
    account_name: "",
    company_tax_id: "",
    sales_tax_rate: "",
    timezone: "",
    currency: "",
    zip_code: "",
    address: "",
    address_2: "",
    country_id: "",
    city_id: "",
    state_id: "",
    parent_code: "",
    latitude: 0,
    longitude: 0,
  });

  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
  });

  useEffect(() => {
    if (timezones && timezones !== null) {
      setTimezoneArr(timezones);
    }
    if (currencies && currencies.length > 0) {
      setCurrenciesArr(currencies);
    }
    if (states && states !== null) {
      setStateArr(states);
    }
    if (country && country !== null) {
      setCountryArr(country);
    }
  }, [timezones, currencies, states, country]);
  useEffect(() => {
    if (apiStates && apiStates !== null) {
      setStateArr(apiStates);
    }
  }, [apiStates]);

  useEffect(() => {
    if (
      account?.merchant?.parent_merchant_id == 0 ||
      account?.merchant?.parent_merchant_id == null
    ) {
      changeInputHandler(
        "balance_sheet",
        account?.merchant?.merchant_balance_sheet_id ?? ""
      );
      changeInputHandler(
        "company_name",
        account?.merchant?.merchant_balance_sheet?.balance_sheet_name ?? ""
      );
      changeInputHandler(
        "incorporation_date",
        account?.merchant?.incorporation_date
          ? moment(account?.merchant?.incorporation_date).toDate()
          : ""
      );
      changeInputHandler(
        "company_tax_id",
        account?.merchant?.company_tax_id ?? ""
      );
    } else {
      setBalanceSheetId(parent_merchant?.merchant_balance_sheet_id ?? "");
      if (account?.merchant?.is_new_balance_sheet == 1) {
        changeInputHandler(
          "company_name",
          account?.merchant?.merchant_balance_sheet?.balance_sheet_name ??
            "Store #1"
        );
        changeInputHandler(
          "incorporation_date",
          account?.merchant?.incorporation_date
            ? moment(account?.merchant?.incorporation_date).toDate()
            : ""
        );
        changeInputHandler(
          "company_tax_id",
          account?.merchant?.company_tax_id ?? ""
        );
      } else {
        changeInputHandler(
          "company_name",
          checkNull(
            account?.merchant?.merchant_balance_sheet?.balance_sheet_name,
            false
          )
            ? account?.merchant?.merchant_balance_sheet?.balance_sheet_name
            : checkNull(
                parent_merchant?.merchant_balance_sheet?.balance_sheet_name,
                ""
              )
        );
        changeInputHandler(
          "incorporation_date",
          checkNull(account?.merchant?.incorporation_date, false)
            ? moment(account?.merchant?.incorporation_date).toDate()
            : checkNull(parent_merchant?.incorporation_date, false)
            ? moment(parent_merchant?.incorporation_date).toDate()
            : ""
        );
        changeInputHandler(
          "company_tax_id",
          checkNull(account?.merchant?.company_tax_id, false)
            ? account?.merchant?.company_tax_id
            : checkNull(parent_merchant?.company_tax_id, "")
        );
        changeInputHandler(
          "balance_sheet",
          checkNull(account?.merchant?.merchant_balance_sheet_id, false)
            ? account?.merchant?.merchant_balance_sheet_id
            : checkNull(parent_merchant?.merchant_balance_sheet_id, "")
        );
      }
    }
    changeInputHandler("account_name", account?.merchant?.account_name ?? "");

    changeInputHandler(
      "sales_tax_rate",
      account?.merchant?.sales_tax_rate ?? ""
    );
    changeInputHandler("timezone", account?.timezone ?? "");
    changeInputHandler("address", account?.merchant?.address ?? "");
    changeInputHandler("address_2", account?.merchant?.address_2 ?? "");
    changeInputHandler("parent_code", account?.parent_code ?? "");
    changeInputHandler("country_id", account?.merchant?.country_id ?? "");
    changeInputHandler(
      "city_id",
      account?.merchant?.city_id && account?.merchant?.city_id > 0
        ? account?.merchant?.city_id
        : ""
    );
    changeInputHandler("zip_code", account?.merchant?.zip_code ?? "");
    if (account?.merchant?.parent_merchant_id == 0) {
      changeInputHandler("currency", account?.merchant?.currency ?? "");
    } else {
      changeInputHandler("currency", parent_currency ?? "");
    }
  }, [account]);

  useEffect(() => {
    if (parent_balance_sheets && parent_balance_sheets.length > 0) {
      setParentBalanceSheetsArr(parent_balance_sheets);
    }
  }, [parent_balance_sheets]);

  const changeInputHandler = (input, val) => {
    setValue(input, val);
    setInputForm((prevState) => ({ ...prevState, [input]: val }));
    if (input == "country_id") {
      const stateQuery = checkNull(val, false) ? `?country_id=${val}` : "";
      dispatch(getState(stateQuery));
      changeInputHandler("state_id", "");
    }
  };

  const onDateChange = (val) => {
    setValue("incorporation_date", val);
    setInputForm((prevState) => ({
      ...prevState,
      incorporation_date: val,
    }));
  };

  useEffect(() => {
    dispatch(getSetupDetails(1));
  }, []);

  const mapChangeHandler = (values) => {
    console.log("values", values);
    changeInputHandler("address", values?.address_line ?? "");
    if (
      values?.country &&
      Object.values(countryArr).indexOf(values?.country) > -1
    ) {
      Object.keys(countryArr).map((index) => {
        if (countryArr?.[index] == values?.country) {
          changeInputHandler("country_id", index);
        }
      });
    }
    changeInputHandler("city_id", values?.city ?? "");
    changeInputHandler("zip_code", values?.zip_code ?? "");
    changeInputHandler("latitude", values?.lat ?? "");
    changeInputHandler("longitude", values?.lng ?? "");
  };

  const onFormSubmit = (data) => {
    data.incorporation_date = moment(data.incorporation_date).format(
      "yyyy-MM-DD"
    );
    console.log("sub_data:", data);
    dispatch(saveSetupWizardForm("one", data, isLogoutRef?.current));
  };

  const submitNextHandler = (isLogoutType = false) => {
    isLogoutRef.current = isLogoutType;
    if (submitBtnRef !== null) {
      submitBtnRef.current.click();
    }
  };

  return (
    <SWInterface step={1}>
      <div className="steps-content row_count2">
        <div className="steps-div_outer">
          <div className="steps-div d-block">
            <h4 className="event-alert mb-0"> Account Details </h4>
            <p className="mt-0">
              Let’s get you started, please tell us a little about your
              business.
            </p>
            <div className="other_input newForm_sec mt-2">
              <div className="form-sec ingredient-info edit-shift">
                <form onSubmit={handleSubmit(onFormSubmit)}>
                  <div className="row mx-0 mb-5">
                    <div className="col-md-6 px-4 pl0">
                      {account?.merchant?.parent_merchant_id > 0 && (
                        <>
                          <div className="form-group groups">
                            <label className="col-md-4">
                              <sup
                                data-bs-placement="bottom"
                                data-bs-toggle="tooltip"
                                title=""
                              >
                                ?
                                <div class="sup tooltip-sm">
                                  {" "}
                                  If sharing a common balance sheet between this
                                  account and any other existing linked
                                  account(s), please select the name of the
                                  shared balance sheet. This will inherit the
                                  existing chart of accounts structure and
                                  balances into this account and any GL
                                  transactions performed on this account will be
                                  visible with the applicable linked accounts
                                  sharing the same balance sheet. Otherwise, if
                                  this account has a standalone balance sheet,
                                  please keep the selection to “New”.{" "}
                                </div>
                              </sup>
                              Balance Sheet{" "}
                            </label>
                            <div className=" col-md-8">
                              <div className="input-group select-div">
                                <select
                                  {...register("balance_sheet")}
                                  name="balance_sheet"
                                  className="valid"
                                  id="ParentBalanceSheet"
                                  value={inputForm?.balance_sheet}
                                  onChange={(e) => {
                                    changeInputHandler(
                                      "balance_sheet",
                                      e?.target?.value
                                    );
                                  }}
                                >
                                  <option value="">
                                    Select Parent Balance Sheet
                                  </option>
                                  {parentBalanceSheetsArr.length > 0 &&
                                    parentBalanceSheetsArr.map(
                                      (parentBalanceSheets, parIndx) => {
                                        return (
                                          <option
                                            value={parentBalanceSheets?.id}
                                            key={parIndx}
                                          >
                                            {parentBalanceSheets?.value}
                                          </option>
                                        );
                                      }
                                    )}
                                  <option value="new">New Sheet</option>
                                </select>
                                <ErrorContainer
                                  errors={errors}
                                  name="balance_sheet"
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      )}

                      <div className="form-group groups">
                        <label className="required col-md-4">
                          <sup
                            data-bs-placement="bottom"
                            data-bs-toggle="tooltip"
                            title=""
                          >
                            ? <div class="sup tooltip-sm"> Tooltip </div>
                          </sup>
                          Account Name
                        </label>
                        <div className="input-fields col-md-8">
                          {" "}
                          <input
                            {...register("account_name")}
                            name="account_name"
                            id="account_name"
                            className="valid"
                            maxlength="200"
                            type="text"
                            value={inputForm?.account_name}
                            onChange={(e) => {
                              changeInputHandler(
                                "account_name",
                                e?.target?.value
                              );
                            }}
                          />{" "}
                          <ErrorContainer errors={errors} name="account_name" />
                        </div>
                      </div>

                      <div className="form-group groups newsheet">
                        <label className="required col-md-4">
                          <sup
                            data-bs-placement="bottom"
                            data-bs-toggle="tooltip"
                            title=""
                          >
                            <div class="sup tooltip-sm"> Tooltip </div>
                          </sup>
                          Company Name{" "}
                        </label>
                        <div className=" col-md-8">
                          <div className="input-group">
                            <input
                              {...register("company_name")}
                              name="company_name"
                              className="valid"
                              maxlength="255"
                              type="text"
                              value={inputForm?.company_name}
                              onChange={(e) => {
                                changeInputHandler(
                                  "company_name",
                                  e?.target?.value
                                );
                              }}
                            />
                            <ErrorContainer
                              errors={errors}
                              name="company_name"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="form-group groups">
                        <label className="required col-md-4">
                          {" "}
                          Company Tax ID
                        </label>
                        <div className="input-fields col-md-8">
                          {" "}
                          <input
                            {...register("company_tax_id")}
                            className="valid"
                            type="text"
                            value={inputForm?.company_tax_id}
                            onChange={(e) => {
                              changeInputHandler(
                                "company_tax_id",
                                e?.target?.value
                              );
                            }}
                          />
                          <ErrorContainer
                            errors={errors}
                            name="company_tax_id"
                          />
                        </div>
                      </div>

                      <div className="form-group groups">
                        <label className="required col-md-4">
                          <sup
                            data-bs-placement="bottom"
                            data-bs-toggle="tooltip"
                            title=""
                          >
                            ? <div class="sup tooltip-sm"> Tooltip </div>
                          </sup>{" "}
                          Date of Incorporation
                        </label>
                        <div className="input-fields col-md-8">
                          <div className="date-sec">
                            <span className="add-on pull-right other-income-addon">
                              <i className="fa fa-calendar"></i>
                            </span>
                            <DatePicker
                              {...register("incorporation_date")}
                              name="incorporation_date"
                              autoComplete="new-password"
                              dateFormat="yyyy-MM-dd"
                              onChange={onDateChange}
                              selected={inputForm?.incorporation_date}
                            />
                          </div>
                          <ErrorContainer
                            errors={errors}
                            name="incorporation_date"
                          />
                        </div>
                      </div>

                      <div className="form-group groups">
                        <label className="required col-md-4">
                          {" "}
                          Sales Tax Rate(%)
                        </label>
                        <div className="input-fields col-md-8">
                          {" "}
                          <input
                            className="valid"
                            type="text"
                            {...register("sales_tax_rate")}
                            value={inputForm?.sales_tax_rate}
                            onChange={(e) => {
                              changeInputHandler(
                                "sales_tax_rate",
                                e?.target?.value
                              );
                            }}
                          />
                          <ErrorContainer
                            errors={errors}
                            name="sales_tax_rate"
                          />
                        </div>
                      </div>
                      {account?.merchant?.parent_merchant_id > 0 && (
                        <div className="form-group groups">
                          <label className="required col-md-4">
                            Parent Account
                          </label>
                          <div className="input-fields col-md-8">
                            {parent_name}
                          </div>
                        </div>
                      )}
                      {checkNull(account?.parent_code, false) && (
                        <div className="form-group groups">
                          <label>Parent Account</label>
                          <div className="input-fields col-md-8">
                            <input
                              className="valid"
                              type="text"
                              {...register("parent_code")}
                              value={inputForm?.parent_code}
                              readOnly
                            />
                            <ErrorContainer
                              errors={errors}
                              name="parent_code"
                            />
                          </div>
                        </div>
                      )}
                      <div className="form-group groups">
                        <label className="col-md-4"> Timezone</label>
                        <div className="input-fields col-md-8">
                          {console.log("timezoneeeee", errors)}
                          <select
                            className="select-box"
                            {...register("timezone")}
                            value={inputForm?.timezone}
                            onChange={(e) => {
                              changeInputHandler("timezone", e?.target?.value);
                            }}
                          >
                            <option value="">Select</option>
                            {timezoneArr !== null &&
                              Object.keys(timezoneArr).map((index) => {
                                return (
                                  <option value={index} key={index}>
                                    {" "}
                                    {timezoneArr?.[index]}{" "}
                                  </option>
                                );
                              })}
                          </select>
                          <ErrorContainer errors={errors} name="timezone" />
                        </div>
                      </div>
                      {account?.merchant?.parent_merchant_id == 0 && (
                        <div className="form-group groups">
                          <label className="col-md-4"> Currency</label>
                          <div className="input-fields col-md-8">
                            <select
                              className="select-box"
                              {...register("currency")}
                              value={inputForm?.currency}
                              onChange={(e) => {
                                changeInputHandler(
                                  "currency",
                                  e?.target?.value
                                );
                              }}
                            >
                              <option value="">Select Currency</option>
                              {currenciesArr.length > 0 &&
                                currenciesArr.map((currency) => {
                                  return (
                                    <option
                                      value={currency?.currency_name}
                                      key={currency?.id}
                                    >
                                      {currency?.currency_name}{" "}
                                    </option>
                                  );
                                })}
                            </select>
                            <ErrorContainer errors={errors} name="currency" />
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="col-md-6 px-4 pr0">
                      <h4 className="event-alert mt-n1 col-12">
                        {" "}
                        Account Administrator{" "}
                      </h4>
                      <div className="form-group groups">
                        <label className="required col-md-4">
                          {" "}
                          Administrator Name{" "}
                        </label>
                        <div className="input-fields col-md-8">
                          {" "}
                          {`${account?.first_name} ${account?.last_name}`}{" "}
                        </div>
                      </div>

                      <div className="form-group groups">
                        <label className="required col-md-4">
                          {" "}
                          Administrator Email{" "}
                        </label>
                        <div className="input-fields col-md-8">
                          {`${account?.email ?? ""}`}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 position-relative">
                      <MyGoogleMap mapChangeHandler={mapChangeHandler} />
                    </div>
                    <input
                      hidden
                      type="text"
                      {...register("latitude")}
                      value={inputForm?.latitude}
                    />
                    <input
                      hidden
                      type="text"
                      {...register("longitude")}
                      value={inputForm?.longitude}
                    />
                    <div className="col-md-6 px-4 pr0">
                      <div className="form-group groups">
                        <label className="col-md-4">Zip Code</label>
                        <div className="input-fields col-md-8">
                          {" "}
                          <input
                            className="valid"
                            type="text"
                            {...register("zip_code")}
                            value={inputForm?.zip_code}
                            onChange={(e) => {
                              changeInputHandler("zip_code", e?.target?.value);
                            }}
                          />
                          <ErrorContainer errors={errors} name="zip_code" />
                        </div>
                      </div>

                      <div className="form-group groups">
                        <label className="required col-md-4">
                          Address Line #1{" "}
                        </label>
                        <div className="input-fields col-md-8">
                          {" "}
                          <input
                            className="valid"
                            type="text"
                            {...register("address")}
                            value={inputForm?.address}
                            onChange={(e) => {
                              changeInputHandler("address", e?.target?.value);
                            }}
                          />
                          <ErrorContainer errors={errors} name="address" />
                        </div>
                      </div>

                      <div className="form-group groups">
                        <label className="col-md-4"> Address Line #2</label>
                        <div className="input-fields col-md-8">
                          {" "}
                          <input
                            className="valid"
                            type="text"
                            {...register("address_2")}
                            value={inputForm?.address_2}
                            onChange={(e) => {
                              changeInputHandler("address_2", e?.target?.value);
                            }}
                          />
                          <ErrorContainer errors={errors} name="address_2" />
                        </div>
                      </div>

                      <div className="form-group groups">
                        <label className="required col-md-4"> Country</label>
                        <div className="input-fields col-md-8">
                          <select
                            className="select-box"
                            {...register("country_id")}
                            value={inputForm?.country_id}
                            onChange={(e) => {
                              changeInputHandler(
                                "country_id",
                                e?.target?.value
                              );
                            }}
                          >
                            <option value=""> Select Country </option>
                            {countryArr !== null &&
                              Object.keys(countryArr).map((index) => {
                                return (
                                  <option value={index} key={index}>
                                    {" "}
                                    {countryArr?.[index]}{" "}
                                  </option>
                                );
                              })}
                          </select>
                          <ErrorContainer errors={errors} name="country_id" />
                        </div>
                      </div>

                      <div className="form-group groups">
                        <label className="required col-md-4"> State </label>
                        <div className="input-fields col-md-8">
                          <select
                            className="select-box"
                            {...register("state_id")}
                            value={inputForm?.state_id}
                            onChange={(e) => {
                              changeInputHandler("state_id", e?.target?.value);
                            }}
                          >
                            <option value=""> Select State </option>
                            {stateArr !== null &&
                              Object.keys(stateArr).map((index) => {
                                return (
                                  <option value={index} key={index}>
                                    {" "}
                                    {stateArr?.[index]}{" "}
                                  </option>
                                );
                              })}
                          </select>
                          <ErrorContainer errors={errors} name="state_id" />
                        </div>
                      </div>

                      <div className="form-group groups">
                        <label className="required col-md-4"> City </label>
                        <div className="input-fields col-md-8">
                          {" "}
                          <input
                            className="valid"
                            type="text"
                            {...register("city_id")}
                            value={inputForm?.city_id}
                            onChange={(e) => {
                              changeInputHandler("city_id", e?.target?.value);
                            }}
                          />
                          <ErrorContainer errors={errors} name="city_id" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <button
                    type="submit"
                    style={{ display: "none" }}
                    ref={submitBtnRef}
                  >
                    Submit
                  </button>
                  <BtmButtons submitHandler={submitNextHandler} />
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SWInterface>
  );
};
export default SetupWizardTwo;
